import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-hero',
    templateUrl: './hero.component.html',
})
export class HeroComponent extends Block {

}
